import { render } from "./fundingdata.vue?vue&type=template&id=1e551a68&scoped=true"
import script from "./fundingdata.vue?vue&type=script&lang=js"
export * from "./fundingdata.vue?vue&type=script&lang=js"

import "./fundingdata.vue?vue&type=style&index=0&id=1e551a68&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\GCTUSMS\\codev1\\apply_online\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e551a68"]])

export default __exports__